import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { DwTileConfig } from '../../../z-devware/visualizations/models/dw-tile-config.model';

@Component({
  selector: 'app-profit-sharing-summary',
  templateUrl: './profit-sharing-summary.component.html',
  styleUrls: ['./profit-sharing-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfitSharingSummaryComponent {
  @Input() tileConfigs: DwTileConfig[] = [];
  @Input() detailsSubmitted = false;
  @Input() chargesEnabled = false;
  @Input() reduceSchoolInvoices = false;
  @Input() busy = false;
  @Input() showStartOver = false;
  @Input() setupActionLabel: 'Enable Profit Sharing' | 'Finish Setup' | null = null;

  @Output() startOver = new EventEmitter<void>();
  @Output() setupAction = new EventEmitter<void>();
  @Output() reduceSchoolInvoicesChange = new EventEmitter<boolean>();

  trackTile(index: number, tile: DwTileConfig): string {
    return tile.containerTitle || index.toString();
  }

  onReduceSchoolInvoicesChange(reduceSchoolInvoices: boolean): void {
    this.reduceSchoolInvoicesChange.emit(reduceSchoolInvoices);
  }
}
